<template>
    <section class="b-gallery vue-lightbox">
        <figure class="b-gallery-big">
            <img :src="bigImage.desctop + '?ver=1'" @click.prevent="openGallery(0)" class="flat-item__img"/>
          <img :src="bigImage.mobile" @click.prevent="openGallery(0)" class="flat-item__img--mobile"/>
        </figure>
        <ul class="flat-gallery-list clean-list">
            <li class="flat-gallery-list__item-wrap" v-for="(item, index) in media"  v-if="index <= 2">
                <figure class="flat-gallery-list__item" :class="{ 'flat-gallery-list__item--active': index === activeItem}" @click.prevent="setBigImage(index)" v-if="index !=2">
                    <img :src="item.thumb" />
                </figure>

                <figure class="flat-gallery-list__item  flat-gallery-list__item--more" @click.prevent="openGallery(2)"  v-if="(index === 2) && (media.length > 2)">               <svg viewBox="0 0 30 30" ><use xlink:href="/assets/site/images/sprites.svg?ver=12#sprite-zoom-in"></use></svg>
                    <img :src="item.thumb" />
                </figure>

            </li>
        </ul>
        <LightBox ref="lightbox"
                  :media="media"
                  :show-caption="false"
                  :show-light-box="false"></LightBox>
    </section>
</template>
<script>
    import LightBox from 'vue-image-lightbox'
    export default {
        props:['media'],
        components: {
            'LightBox':LightBox,
        },
        data() {
            return {
                bigImage: {
                  desctop:"",
                  mobile:""
                },
                activeItem: 0,
            }
        },
        methods: {
            openGallery(i) {
                if(parseInt(i) >  0) {
                    this.$refs.lightbox.showImage(i);
                } else {
                    this.$refs.lightbox.showImage(this.activeItem);
                }

            },
            setBigImage(index) {
                this.activeItem = index;
                this.bigImage.desctop = this.media[index].big;
              this.bigImage.mobile = this.media[index].mobile;
            }
        },
        mounted() {
            if(this.media[0]){
              console.log(this.media)
              this.bigImage.desctop = this.media[0].big;
              this.bigImage.mobile = this.media[0].mobile;
            }

        }
    }
</script>
